import script from "./CaskSteamGameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskSteamGameCard.vue?vue&type=script&setup=true&lang=js"

import "./CaskSteamGameCard.vue?vue&type=style&index=0&id=ca2baae2&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca2baae2"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QImg,QBtn});
